import Rekv from 'rekv';

const modal = new Rekv({
  donateModalShow: false,
  switchModalShow: false,
});

export default modal;
